/**
 * LayoutItem.js
 * Created on 23-apr-2014
 * 
 * WISHES:
 * - take transform (scaling, rotation, offset) of target's parent into account
 * - implement remaining FillArea types
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/

import Anchor from "./Anchor";
import FillArea from "./FillArea";

export default class LayoutItem {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {Anchor} anchor 
     * @param {FillArea} fillArea 
     */
    constructor(target, anchor, fillArea) {
        this.target = target;
        this.anchor = anchor;
        this.fillArea = fillArea;
        //cache initial layout values
        //    this.globalPos = target.parent.localToGlobal(target.x,target.y);
        this.x = target.x;
        this.y = target.y;
        //
        if (this.fillArea) {
            this.scaleX = target.scaleX;
            this.scaleY = target.scaleY;
        }
    }

    destroy(resetPosition = false) {
        this.target.x = this.x;
        this.target.y = this.y;
        this.target = this.fillArea = null;
    }

    update(root, vp, vpOriginal) {
        if (this.fillArea) {
            this._updateFillArea(root, vp, vpOriginal);
        }
        if (this.anchor) {
            this._updateAnchor(root, vp, vpOriginal);
        }
    }

    /**
     * TODO:
     * Currently, this method does not take registration point into account!
     * Target is just scaled around reg point, so make sure the target is center aligned with reg point at 0,0
     */
    _updateFillArea(root, vp, vpOriginal) {
        //FillArea is a rect defining target's bounds in original viewport.
        //Using width and height of these bounds, the target will be scaled according to type (FillArea.WIDTH etc)
        const f = this.fillArea;
        switch (f.type) {
            case FillArea.WIDTH:
                this._scaleToWidth(f, vp, vpOriginal);
                break;
            case FillArea.HEIGHT:
                this._scaleToHeight(f, vp, vpOriginal);
                break;
            case FillArea.STRETCH:
                this._scaleToWidth(f, vp, vpOriginal);
                this._scaleToHeight(f, vp, vpOriginal);
                break;
            case FillArea.PROPORTIONAL_OUTSIDE:
                this._scaleOutside(f, vp, vpOriginal);
                break;
            case FillArea.PROPORTIONAL_INSIDE:
                this._scaleInside(f, vp, vpOriginal);
                break;
        }
    }

    _scaleToWidth(f, vp, vpOriginal) {
        this.target.scaleX = this.calcScaleX(f, vp, vpOriginal);
    }

    _scaleToHeight(f, vp, vpOriginal) {
        this.target.scaleY = this.calcScaleY(f, vp, vpOriginal);
    }

    _scaleOutside(f, vp, vpOriginal) {
        const sx = this.calcScaleX(f, vp, vpOriginal);
        const sy = this.calcScaleY(f, vp, vpOriginal);
        var scale = Math.max(sx, sy);
        this.target.scaleX = this.target.scaleY = scale;
    }

    _scaleInside(f, vp, vpOriginal) {
        const sx = this.calcScaleX(f, vp, vpOriginal);
        const sy = this.calcScaleY(f, vp, vpOriginal);
        const scale = Math.min(sx, sy);
        this.target.scaleX = this.target.scaleY = scale;
    }

    calcScaleX(f, vp, vpOriginal) {
        const wf = vp.width - (vpOriginal.width - f.width);
        return this.scaleX * (wf / f.width);
    }

    calcScaleY(f, vp, vpOriginal) {
        const hf = vp.height - (vpOriginal.height - f.height);
        return this.scaleY * (hf / f.height);
    }

    _updateAnchor(root, vp, vpOriginal) {
        const a = this.anchor;
        const x = vp.x, y = vp.y, w = vp.width, h = vp.height;
        const xo = vpOriginal.x, yo = vpOriginal.y, wo = vpOriginal.width, ho = vpOriginal.height;
        //calc original offset from anchor
        const pAnchorOrig = root.localToLocal(xo + a.x * wo, yo + a.y * ho, this.target.parent);
        const pAnchor = root.localToLocal(x + a.x * w, y + a.y * h, this.target.parent);
        this.target.x = this.x + pAnchor.x - pAnchorOrig.x;
        this.target.y = this.y + pAnchor.y - pAnchorOrig.y;
        return;

        var dx = this.x - a.x * wo;
        var dy = this.y - a.y * ho;
        this.target.x = a.x * w + dx;
        this.target.y = a.y * h + dy;
        //    var dx = this.globalPos.x - a.x*wo;
        //    var dy = this.globalPos.y - a.y*ho;
        //    var local = this.target.parent.globalToLocal(a.x*w + dx, a.y*h + dy);
        //    this.target.x = local.x;
        //    this.target.y = local.y;
    }
}




